import React from "react";
import boldeeLogo from '../../../assets/images/logo_boldee_green.png'
import classes from './LogoLogin.module.css';

const LogoLogin = (props) => {
    return(
        <div className={classes.Logo}>
            <img src={boldeeLogo} alt="logo"/>
        </div>
    )
}
export default LogoLogin;